import styled from 'styled-components';
import { colors } from 'themes/variables';

export const StyledCookieDeclaration = styled.div`
  padding: 130px 0 30px;
  background-color: #151412;
  color: #FFF;
  .content {
    a {
      color: ${colors.green};
    }
    h1 {
      font-size: 3.6em;
      font-weight: bold;
      margin-bottom: 30px;
    }
    p {
      font-size: 2em;
      margin-bottom: 30px;
      button, a {
        padding: 0;
        color: ${colors.green};
        cursor: pointer;
      }
    }
  }
`;

export const StyledCookies = styled.div`
  padding-bottom: 30px;
  h3 {
    font-size: 3em;
    font-weight: bold;
    margin-bottom: 15px;
  }
  table {
    width: 100%;
    margin-bottom: 30px;
    border: solid 1px #333;
    th, td {
      font-size: 1.6em;
      padding: 10px;
      vertical-align: top;
    }
    th {
      font-weight: bold;
      border: solid 1px #333;
      border-bottom: solid 2px #333;
    }
    td {
      border: solid 1px #333;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/containers/CookieDeclaration/styles.js